import React from 'react';
import withIcon from '../utilities/withIcon';

const IconVideoStart = () => {
  return (
    <g>
      <path d="M1.75 16a.75.75 0 0 1-.75-.75V.75a.75.75 0 1 1 1.5 0v5.982L13.885.102a.752.752 0 0 1 1.008.237c.07.11.107.236.107.365v14.592c0 .389-.329.704-.734.704a.758.758 0 0 1-.38-.102L2.5 9.269v5.981a.75.75 0 0 1-.75.75zm11.75-2.062V2.063L3.301 8 13.5 13.938z" />
    </g>
  );
};

export default withIcon(IconVideoStart);
